<template>
  <svg
    width="14px"
    height="18px"
    viewBox="0 0 14 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>geo2</title>
    <g
      id="Activity-Monitor"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1499.000000, -162.000000)"
        fill="#006F72"
        fill-rule="nonzero"
        id="Activity-Stream"
      >
        <g transform="translate(1467.000000, 0.000000)">
          <g
            id="Group-9"
            transform="translate(20.000000, 151.090909)"
          >
            <g
              id="geo2"
              transform="translate(12.000000, 11.000000)"
            >
              <path
                d="M7,0 C4.583775,0 2.625,1.959125 2.625,4.375 C2.625,5.194 3.0118375,6.20111625 3.71875,7.41041 C3.9542125,7.81291 4.2468125,8.21016 4.5390625,8.64066 C4.9331625,9.22166 5.348875,9.82016 5.76975,10.363535 C5.866,10.48691 5.9955,10.659285 6.125,10.82816 L6.125,13.125035 C6.125,13.608035 6.517,14.000035 7,14.000035 C7.483,14.000035 7.875,13.608035 7.875,13.125035 L7.875,10.82816 C8.0045,10.659285 8.134,10.48691 8.23025,10.363535 C8.651125,9.821035 9.06675,9.22166 9.4605,8.64066 C9.75275,8.21016 10.045875,7.81291 10.28125,7.41041 C10.98825,6.20111625 11.375,5.194 11.375,4.375 C11.375,1.959125 9.415875,0 7,0 Z M7,1.75 C8.449875,1.75 9.625,2.925125 9.625,4.375 C9.625,4.7915 9.309125,5.55186625 8.75,6.50824125 C8.535625,6.87399125 8.31075,7.283535 8.0395,7.68341 C7.71225,8.165535 7.35175,8.618785 7,9.07816 C6.64825,8.618785 6.288625,8.165535 5.9605,7.68341 C5.68925,7.283535 5.464375,6.87399125 5.25,6.50824125 C4.69105,5.55186625 4.375,4.7915 4.375,4.375 C4.375,2.925125 5.550125,1.75 7,1.75 Z M7,3.5 C6.517,3.5 6.125,3.892 6.125,4.375 C6.125,4.858 6.517,5.25 7,5.25 C7.483,5.25 7.875,4.858 7.875,4.375 C7.875,3.892 7.483,3.5 7,3.5 Z M3.199175,10.2269475 C1.2604375,10.9050725 0,12.09166 0,13.562535 C0,15.902285 3.196025,17.500035 7,17.500035 C10.803625,17.500035 14,15.902285 14,13.562535 C14,12.08816 12.718125,10.9041975 10.773,10.2269475 C10.317125,10.0676975 9.8385,10.31716 9.67925,10.773035 C9.520875,11.229785 9.743125,11.70841 10.199,11.866785 C11.521125,12.32791 12.25,13.007785 12.25,13.562535 C12.25,14.605535 9.961875,15.750035 7,15.750035 C4.038475,15.750035 1.75,14.605535 1.75,13.562535 C1.75,13.009535 2.457,12.32791 3.7734375,11.866785 C4.229575,11.707535 4.4799125,11.229785 4.3203125,10.773035 C4.1607125,10.31716 3.6553125,10.0668225 3.199175,10.2269475 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
